export default __webpack_public_path__ + "static/media/screen_4.d4426c4f.png";